import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { AppService } from '@app/app.service';
import { LoadingOverlayService } from '@app/shared/loading-overlay/loading-overlay.service';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatSlideToggleModule,
  ],
  templateUrl: './settings.html',
  styleUrl: './settings.scss',
})
export class Settings implements OnInit {

  registration_enabled: boolean = true;
  login_enabled: boolean = true;
  maintenance_mode: boolean = false;

  isUpdating: boolean = false;

  constructor(
    private appService: AppService,
    private loadingOverlay: LoadingOverlayService,
  ) {}

  ngOnInit(): void {
    this.getSettings();
  }

  getSettings(): void {
    this.loadingOverlay.show();

    this.appService.getSettings().subscribe({
      next: (response) => {
        const settings = response.data;

        this.registration_enabled = settings.registration_enabled;
        this.login_enabled = settings.login_enabled;

        this.loadingOverlay.hide();
      },
      error: (error) => {
        this.loadingOverlay.hide();
        this.appService.handleError(error);
      }
    });
  }

  updateSettings(): void {
    this.isUpdating = true;

    const data = {
      registration_enabled: this.registration_enabled,
      login_enabled: this.login_enabled,
      maintenance_mode: this.maintenance_mode,
    };

    this.appService.updateSettings(data).subscribe({
      next: (response) => {
        this.isUpdating = false;
        this.appService.successSnackBar(response.message);
      },
      error: (error) => {
        this.isUpdating = false;
        this.appService.handleError(error);
      }
    });
  }

}